import { render } from "./DataTablePartDb.vue?vue&type=template&id=4a0c68ba&scoped=true"
import script from "./DataTablePartDb.vue?vue&type=script&lang=js"
export * from "./DataTablePartDb.vue?vue&type=script&lang=js"

import "./DataTablePartDb.vue?vue&type=style&index=0&id=4a0c68ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0c68ba"]])

export default __exports__